export default {
  clearFilterButton: 'Clear filter',
  applyButton: 'Apply',
};
